import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Td_Sel from "../../lib/ui/td_sel";
import Dd_Sel from "../../lib/ui/dd_sel";
import * as utils from '../../assets/utils.js'

import Preg_New from "./pres/preg_new";
import Preg_Edit from "./pres/preg_edit";
import Preg_Trs from "./pres/pres_trs";
import Preg_Full from "./pres/pres_full";
import PdfRpDlg from "./fkn/pdf_rp_dlg";
import Preg_Saldo from "./pres/pres_saldo";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Pres extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.pra = [];
    this.state.prs = [];
    this.state.prt = [];
    this.state.kro = {};
    this.state.ta = [
                {id: '01', text: 'PRESENTKORT'},
                {id: '02', text: 'VIPKORT'}
        ];
    this.state.wnds = {};
    this.state.tot = {};
    this.state.act = {};
    this.state.sz_val = "";
    this.state.showall = 0;

    this.selitems = [
        {fkn: 'open', text: 'ÖPPNA'}
    ];
    /*
    this.fknitems = [
        {fkn: 'preg_prn', text: 'SKRIV UT'},
        {fkn: 'preg_reg', text: 'HELA REGISTRET'},
       {fkn: 'preg_inx', text: 'INDEXERA REGISTER'},
        {fkn: 'preg_gen', text: 'GENERERA REGISTER'},
        {fkn: 'preg_imp', text: 'IMPORTERA REGISTER'}
      ];
      */
      this.fknitems = [
        {fkn: 'preg_saldo', text: 'SALDO'},
        {fkn: 'preg_trs', text: 'TRANSAKTIONER'},
        {fkn: 'preg_reg', text: 'HELA REGISTRET'},
        {fkn: 'preg_prn', text: 'SKRIV UT'},
        {fkn: 'preg_gen', text: 'GENERERA REGISTER'},
      ];
      this.state.pdf = 0;
      this.state.pdf_content = null;
    }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.presreg();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 255;
      css.overflow = "auto";
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  kund_open(row) {
      var self = this;
  }
  kund_edit(row) {
    var self = this;
    var wnds = {};
    wnds.edit = 1;
    wnds.kro = row;
    this.setState({ wnds: wnds });
  }
    preg_imp() {
        var self = this;
        var prm = {};
        //prm.req = "vip.vip_reg.vip_import";
        prm.req = "crs.crs_reg.reg_import";
        prm.sz = "";
        //prm.avd = this.state.avd;
        //alert(JSON.stringify(prm));
        //prm.sid = "S0001611";
    
        //net.sid_req(prm)
        net.sio_req(prm)
         .then(function(ret){
        //alert(JSON.stringify(ret.rca));
        /*
            self.setState({paa: ret.rca }, function () {
                self.syncTb("presTable");
            });
        */
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
    });
    }
    preg_gen() {
        var self = this;
        var prm = {};
        //prm.req = "vip.vip_reg.vip_import";
        prm.req = "crs.crs_reg.reg_gen";
        prm.sz = "";
        //prm.avd = this.state.avd;
        //alert(JSON.stringify(prm));
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
                .then(function(ret){
                //alert(JSON.stringify(ret.rca));
                /*
                self.setState({paa: ret.rca }, function () {
                    self.syncTb("presTable");
                });

                 */
                //toastr.success("OK", "SAPI");
            })
            .catch(function(e) {
                var txt = JSON.stringify(e);
            });
    }

    presreg() {
    var self = this;
    var prm = {};
    prm.req = "crs.crs_reg.pres_list";
    prm.sz = "";
    //prm.avd = this.state.avd;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({pra: ret.rca, prs: ret.rca, prt: ret.rct, tot: ret.tot, act: ret.act }, function () {
            self.syncTb("presTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            if(!tdElements[i]) continue;
            if(!thElements[i]) continue;
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
  sel_row_fkn(sel, e) {
    //alert(JSON.stringify(fkn));
      if(sel.fkn == "logout") {
      }
  }
  lists() {
  }
    sel_fkn(sel) {
        //alert(JSON.stringify(sel));
        if(sel.fkn == "preg_prn") {
            this.reg_prn();
        }
        if(sel.fkn == "preg_reg") {
            this.preg_full();
        }
        if(sel.fkn == "preg_imp") {
            this.preg_imp();
        }
        if(sel.fkn == "preg_gen") {
            this.preg_gen();
        }
        if(sel.fkn == "preg_trs") {
            this.preg_trs();
        }
        if(sel.fkn == "preg_saldo") {
            this.preg_saldo();
        }
    }

    preg_new() {
        var wnds = {};
        wnds.pregnew = 1;
        wnds.pro = {};
        this.setState({ wnds: wnds });
    }
    preg_edit(row) {
        var wnds = {};
        wnds.pregedit = 1;
        wnds.pro = row;
        this.setState({ wnds: wnds });
    }
    preg_trs() {
        var wnds = {};
        wnds.pregtrs = 1;
        wnds.pro = {};
        this.setState({ wnds: wnds });
    }
    preg_full() {
        var wnds = {};
        wnds.pregfull = 1;
        wnds.pro = {};
        this.setState({ wnds: wnds });
    }
    preg_saldo() {
        var wnds = {};
        wnds.pregsaldo = 1;
        wnds.pro = {};
        this.setState({ wnds: wnds });
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var pra = self.state.pra;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }
        var fa = typ.split(".");
        if(true) {
            if(sortdir) pra.sort((a,b) => (a[fa[0]][fa[1]] < b[fa[0]][fa[1]]) ? 1 : ((b[fa[0]][fa[1]] < a[fa[0]][fa[1]]) ? -1 : 0));
            else pra.sort((a,b) => (a[fa[0]][fa[1]] > b[fa[0]][fa[1]]) ? 1 : ((b[fa[0]][fa[1]] > a[fa[0]][fa[1]]) ? -1 : 0));
        }
        self.setState({ pra: pra, sortid: typ, sortdir: sortdir });
    }

  reg_prn() {
    var self = this;
        //var datum = moment().subtract(14, "days");

        var prm = {};
        prm.req = "crs.crs_reg.rp_preg";
        //prm.fdat = datum.format("YYYYMMDD");
        //prm.tdat = datum.format("YYYYMMDD");
        //prm.sid = "S0001611";

        //net.sid_req(prm)
        net.sio_req(prm)
            .then(function(ret){
            //alert(JSON.stringify(ret.pdf));

            self.setState({ pdf: 1, pdf_content: ret.pdf });
            //toastr.success("OK", "SAPI");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            //gda.wndError(txt);
        });
  }
  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }

  sz_keydown (e) {
    //e.preventDefault();
      const key = e.key;
      const keyCode = e.keyCode;

      if(keyCode == 13) {
          this.pres_sz();
      };
      if(keyCode == 27) {
          this.setState({sz_val: ""});
      };
  }
  sz_change (e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({sz_val: value});
      //setState({[name]: value});
    }
    pres_sz() {
      var self = this;
        var prs = self.state.prs;
    var sz = this.state.sz_val;

    var pra = prs.filter( row => (
        row.pres00.p0id.toUpperCase().includes(sz.toUpperCase()) ||
        row.pres00.p0belopp.toUpperCase().includes(sz.toUpperCase()) ||
        row.pres00.p0saldo.toUpperCase().includes(sz.toUpperCase()) ||
        row.pres01.p1anm.toUpperCase().includes(sz.toUpperCase()) ||
        row.pres02.p2cardnr.toUpperCase().includes(sz.toUpperCase()) ||
        row.pres00.p0text.toUpperCase().includes(sz.toUpperCase())
    ));
    self.setState({ pra: pra });
}

style_pres(row) {
    var self = this;
    var css = {};

    var showall = self.state.showall;
    if(showall == 2) {
        var saldo = row.pres00.p0saldo * 1;
        //if(saldo == 0) css.display = "none";
    }
    return css;
}

showtext() {
    var self = this;
    var txt = "";

    var showall = this.state.showall;
    if(showall == 0) txt = "VISAR ALLA";
    if(showall == 1) txt = "VISAR AKTIVA";
    if(showall == 2) txt = "MED BELOPP";
    return txt;
}

pres_show() {
  var self = this;
    var showall = this.state.showall;
    if(showall == 1) {
        var prs = this.state.prs;
        self.setState({ pra: prs, showall: 2 });
    }
    else if(showall == 2) {
        var prs = this.state.prs;
        self.setState({ pra: prs, showall: 0 });
    }
    else {
        var prt = this.state.prt;
        self.setState({ pra: prt, showall: 1 });
    }
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control sel_input" placeholder="Välj typ">
            { this.state.ta.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
        <div className="flex"></div>
        <input className="txt sztxt" value={this.state.sz_val} onChange={(e) => this.sz_change(e)} onKeyDown={(e) => this.sz_keydown(e)} />
        <div className="flex"></div>
        <button className="btn btn-hw-orange w150" onClick={() => this.preg_new() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-green w150" onClick={() => this.pres_show() } aria-label="System" >
            { this.showtext() }
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.presreg() } aria-label="System" >
            UPPDATERA
        </button>
        <Dd_Sel items={ this.fknitems } cls="web-top-icon" getValue={(e)=> this.sel_fkn(e)} />
    </div>
    <div className="divider_orange"></div>

    <div className="web-col">
        <div id="presTable">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
            <th onClick={() => this.tb_sort("pres00.p0id") }>Pres Nr</th>
            <th onClick={() => this.tb_sort("pres02.p2cardnr") }>Kort Nr</th>
                <th onClick={() => this.tb_sort("pres00.p0text") }>Text</th>
                <th onClick={() => this.tb_sort("pres00.p0datum") }>Datum</th>
                <th onClick={() => this.tb_sort("pres00.p0expire") }>Giltigt</th>
                <th onClick={() => this.tb_sort("pres00.p0belopp") }>Belopp</th>
                <th onClick={() => this.tb_sort("pres00.p0saldo") }>Att utnyttja</th>
                <th onClick={() => this.tb_sort("pres01.p1issuedby") }>Utställt</th>
                <th onClick={() => this.tb_sort("pres01.p1anm") }>Information</th>
                <th></th>
            </tr>
            </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
            { this.state.pra.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.preg_edit(row) }  style={ this.style_pres(row) } >
                <td className="text-center">{ utils.toNum(row.pres00.p0id) }</td>
                <td className="text-center">{ utils.toNum(row.pres02.p2cardnr) }</td>
                <td>{ row.pres00.p0text }</td>
                <td>{ utils.toDate(row.pres00.p0datum) }</td>
                <td>{ utils.toDate(row.pres00.p0expire) }</td>
                <td>{ utils.toPris(row.pres00.p0belopp) }</td>
                <td>{ utils.toPris(row.pres00.p0saldo) }</td>
                <td>{ row.pres01.p1issuedby }</td>
                <td>{ row.pres01.p1anm }</td>
                <td>
                    <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        
        </div>
        </div>

        <div className="divider_green"></div>
        <div className="flex-row px-5">
            <div className="flex">TOTALER:</div>
            <div className="px-5">ANTAL: { utils.toNum(this.state.tot.antal) }</div>
            <div className="px-5">BELOPP: { utils.toPris(this.state.tot.belopp) }</div>
            <div className="px-5">SALDO: { utils.toPris(this.state.tot.saldo) }</div>
        </div>
        <div className="flex-row px-5">
            <div className="flex">AKTIVA:</div>
            <div className="px-5">ANTAL: { utils.toNum(this.state.act.antal) }</div>
            <div className="px-5">BELOPP: { utils.toPris(this.state.act.belopp) }</div>
            <div className="px-5">SALDO: { utils.toPris(this.state.act.saldo) }</div>
        </div>

    </div>
        { this.state.wnds.pregsaldo ? <Preg_Saldo wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.pregnew ? <Preg_New wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.pregedit ? <Preg_Edit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.pregtrs ? <Preg_Trs wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.pregfull ? <Preg_Full wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        <PdfRpDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
   </div>
  );
    }
}
export default Reg_Pres;
